
import { Component, Model, Prop, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: true,
})
export default class AppPagination extends Vue {
  @Model()
  public readonly page!: number;

  @Prop()
  public readonly total!: number;

  public onChange(value: number): void {
    this.$emit("change", value);
  }
}
